import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const ConfirmationPage = () => {
  useEffect(() => {
    // Generate calendar links
    const eventDate = '20251112';
    const startTime = '1400'; // 2:00 PM in 24-hour format
    const endTime = '1530';   // 3:30 PM in 24-hour format
    const title = 'Practical AI for HR Leaders - Build Lab';
    const description = 'Join an interactive 90-minute Build Lab designed for modern HR teams to explore real-world ways AI can enhance productivity, insights, and decision-making.';
    const location = 'Virtual (Zoom)';

    // Google Calendar URL
    const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${eventDate}T${startTime}00/${eventDate}T${endTime}00&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}`;
    
    // Outlook Calendar URL
    const outlookUrl = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&startdt=${eventDate}T${startTime}00&enddt=${eventDate}T${endTime}00&body=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}`;

    const googleCalendarBtn = document.getElementById('google-calendar');
    const outlookCalendarBtn = document.getElementById('outlook-calendar');
    
    if (googleCalendarBtn) googleCalendarBtn.href = googleUrl;
    if (outlookCalendarBtn) outlookCalendarBtn.href = outlookUrl;
  }, []);

  return (
    <div className="confirmation-container">
      <div className="confirmation-card">
        <div className="logo-container">
          <img src="/enculture-logo.png" alt="Enculture Build Labs" className="logo" />
          <span className="logo-text">Enculture Build Labs</span>
        </div>
        <div className="success-icon">✅</div>
        <h1 className="confirmation-title">Registration Confirmed!</h1>
        <p className="confirmation-subtitle">Thank you for registering for the Practical AI for HR Leaders Build Lab. We're excited to have you join us!</p>
        
        <div className="event-summary">
          <h3>Event Details</h3>
          <div className="event-detail">
            <span className="icon">📅</span>
            <span>Wednesday, 12 November 2025</span>
          </div>
          <div className="event-detail">
            <span className="icon">🕑</span>
            <span>2:00 PM – 3:30 PM IST</span>
          </div>
          <div className="event-detail">
            <span className="icon">📍</span>
            <span>Virtual (Zoom)</span>
          </div>
          <div className="event-detail">
            <span className="icon">👥</span>
            <span>Limited Interactive Session</span>
          </div>
        </div>
        
        <div className="calendar-buttons">
          <a href="#google-calendar" className="calendar-btn" id="google-calendar">
            📅 Add to Google Calendar
          </a>
          <a href="#outlook-calendar" className="calendar-btn" id="outlook-calendar">
            📧 Add to Outlook
          </a>
        </div>
        
        <div className="preparation-note">
          <h4>What to Prepare</h4>
          <p>To get the most out of this Build Lab, please bring:</p>
          <ul style={{ marginTop: '12px', paddingLeft: '20px', color: 'var(--gray-600)' }}>
            <li>A sample job description or HR policy document</li>
            <li>Your laptop with internet access</li>
            <li>Any specific HR challenges you'd like to explore with AI</li>
          </ul>
        </div>
        
        <div className="teaser">
          <p><strong>What's Next?</strong><br />
          This Build Lab is the first in our series on Intelligent HR, next up: "AI Automation for HR Teams" coming in December 2025!</p>
        </div>
        
        <div style={{ marginTop: '40px' }}>
          <p style={{ color: 'var(--gray-600)', marginBottom: '20px' }}>
            <strong>You'll receive:</strong><br />
            • Zoom link 24 hours before the event<br />
            • Resource kit download link<br />
            • Preparation checklist
          </p>
          <Link to="/" className="back-btn">← Back to Landing Page</Link>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
